const SHOW_LOGS = false;

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';
      navigator.serviceWorker.register(swUrl)
        .then((registration) => {
          if (SHOW_LOGS) console.log('[Service Worker] Registered:', registration.scope);
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  if (SHOW_LOGS) console.log('[Service Worker] New content available; please refresh.');
                } else {
                  if (SHOW_LOGS) console.log('[Service Worker] Content cached for offline use.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('[Service Worker] Registration failed:', error);
        });
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (SHOW_LOGS) console.log('[Service Worker] Controller changed, reloading...');
        window.location.reload();
      });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[Service Worker] Unregistration error:', error);
      });
  }
}

